import { render, staticRenderFns } from "./ResponsiblePayRollForSignWidget.vue?vue&type=template&id=64a60ebd&scoped=true&"
import script from "./ResponsiblePayRollForSignWidget.vue?vue&type=script&lang=js&"
export * from "./ResponsiblePayRollForSignWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a60ebd",
  null
  
)

export default component.exports